import type {
  BrgExclusionPreFilter,
  EntitlementFilters,
  RecommendationParams,
} from './types'

export function buildBrgExclusionPreFilter(
  excludedRuleGroupIds?: string[],
): BrgExclusionPreFilter | undefined {
  if (!excludedRuleGroupIds?.length) {
    return undefined
  }

  return {
    not: {
      or: excludedRuleGroupIds.map((id) => ({ name: 'brg_id', value: id })),
    },
  }
}

export function buildSimilarRecommendationParams(
  params: {
    sku: string
    variationSku?: string
    categoryGroupIds?: string[]
    resultsPerPage: number
  } & EntitlementFilters,
): RecommendationParams {
  const {
    sku,
    variationSku,
    categoryGroupIds,
    resultsPerPage,
    ruleGroupIds,
    excludedRuleGroupIds,
  } = params

  const requestParameters: RecommendationParams = {
    itemIds: [sku],
    numResults: resultsPerPage,
  }

  if (variationSku) {
    requestParameters.variationId = variationSku
  }

  const filters: Record<string, string[]> = {}

  if (ruleGroupIds) {
    filters.brg_id = ruleGroupIds
  }

  if (categoryGroupIds?.length) {
    filters.group_id = categoryGroupIds
  }

  if (Object.keys(filters).length > 0) {
    requestParameters.filters = filters
  }

  const preFilterExpression = buildBrgExclusionPreFilter(excludedRuleGroupIds)

  if (preFilterExpression) {
    requestParameters.preFilterExpression = preFilterExpression
  }

  return requestParameters
}

export function buildPairsWithRecommendationParams(
  params: { sku: string; resultsPerPage: number } & EntitlementFilters,
): RecommendationParams {
  const { sku, resultsPerPage, ruleGroupIds, excludedRuleGroupIds } = params

  const requestParameters: RecommendationParams = {
    itemIds: [sku],
    numResults: resultsPerPage,
  }

  if (ruleGroupIds) {
    requestParameters.filters = { brg_id: ruleGroupIds }
  }

  const preFilterExpression = buildBrgExclusionPreFilter(excludedRuleGroupIds)

  if (preFilterExpression) {
    requestParameters.preFilterExpression = preFilterExpression
  }

  return requestParameters
}
